import { Suspense } from 'react';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
import { SplashScreen } from 'src/components/loading-screen';
import MainLayout from 'src/layouts/main';
import AboutPage from 'src/pages/about-us';
import FoudationPage from 'src/pages/foundation';
import LiquidityPage from 'src/pages/liquidity';
import TeamPage from 'src/pages/team';
import VenturesPage from 'src/pages/ventures';
import { HomePage } from './main';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),
      children: [
        { element: <HomePage />, index: true },
        { path: 'sr-foundation', element: <FoudationPage /> },
        { path: 'sr-ventures', element: <VenturesPage /> },
        { path: 'sr-liquidity', element: <LiquidityPage /> },
        { path: 'about', element: <AboutPage /> },
        { path: 'team', element: <TeamPage /> },
      ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
  ]);
}
